module.exports = __webpack_public_path__ + "img/aghk-truck-disabled.39a701d6.svg";